import { FC } from "react";
import { Button } from "../../../../../common/components/Button/Button";
import { FormProvider, useForm } from "react-hook-form";
import { KmuMarkFormInputs } from "./KmuMarkFormInputs";
import { useCreateKmuMarkMutation } from "services/vehicle/kmuApi";
import { getErrorMessage } from "common/utils/helpers";
import { Error } from "common/components/Message/Error/Error";
import { Success } from "common/components/Message/Success/Success";

export const KmuMarkAdd: FC = () => {
  const [create, { isLoading, error, isSuccess }] = useCreateKmuMarkMutation();

  const methods = useForm<{
    name: string;
  }>();

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit((data) => {
    create(data);
  });

  if (error) {
    return <Error>{getErrorMessage(error)?.data.message}</Error>;
  }

  if (isSuccess) {
    return <Success>Марка успешно создана!</Success>;
  }

  return (
    <form className="grid gap-[15px]" onSubmit={onSubmit}>
      <FormProvider {...methods}>
        <KmuMarkFormInputs />
      </FormProvider>
      <Button className="w-fit" disabled={isLoading}>
        Сохранить
      </Button>
    </form>
  );
};
